import { useAuth } from '../context/AuthContext';
export const useRoutePath = () => {
  
    const { user } = useAuth();
    const adminPrefix = process.env.REACT_APP_ADMIN_ROUTE_PREFIX || 'admin';
   
    return (path) => (user?.role_id === 1 ? `/${adminPrefix}${path}` : path);
  };
  